import { useCallback } from "react";

import { openSignedPdfUrl } from "src/utils/pdfSignedUrl";

export default function useOpenSignedPdfUrl({
  resourceType,
  resourceId,
  pathSuffix = null,
  extraQueryParams = {},
  target = "_blank",
}) {
  return useCallback(
    (event) => {
      event?.preventDefault();

      return openSignedPdfUrl({
        resourceType,
        resourceId,
        pathSuffix,
        extraQueryParams,
        target,
      });
    },
    [resourceType, resourceId, pathSuffix, JSON.stringify(extraQueryParams), target]
  );
}
